<div class="relay-breadcrumbs">
    <ol class="breadcrumb">
        <li>
            <a routerLink="/home" class="glyphicon glyphicon-home">
                <i class="fas fa-home"></i>
            </a>
        </li>
        <li *ngFor="let item of breadcrumbItems;last as isLast" class="not">
            <span routerLink="{{item.url}}" *ngIf="!isLast" [queryParams]="item.queryParams" style="cursor: pointer; color: #0288d1;">{{item.name}}</span>
            <span *ngIf="isLast" class="last-item">{{item.name}}</span>
        </li>
    </ol>
</div>